 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-088ff9c4":"23905b61","chunk-0f6138b1":"a715ede7","chunk-3c1f000b":"c8550f09","chunk-66c005f6":"09db0fa4","chunk-17aa4263":"4db710fd","chunk-20d3da9c":"5b7bba9c","chunk-23d7671f":"d183f04f","chunk-75ae48cb":"3862cf70","chunk-26388ba0":"8953b559","chunk-26b7f32c":"73a55c38","chunk-2d0c0c33":"88647a94","chunk-2d21a9a9":"2e11395f","chunk-2d21f29d":"ab763b29","chunk-2d22ce37":"f2a60a49","chunk-30685335":"2869f020","chunk-330516b5":"af831e56","chunk-373d13b6":"385140d1","chunk-3ade2b2a":"6b85149e","chunk-51870f86":"4595e123","chunk-713ff3a1":"9533a96b","chunk-1392692b":"1df53ac8","chunk-c132eb58":"c3456f64","chunk-b7a736d6":"0954c48b","chunk-15cd8f4b":"3825ab55","chunk-e13d3680":"c0ed8b9c","chunk-2b10fcfa":"b7c5306f","chunk-727f3b75":"ea060c16","chunk-8eddf8fa":"e7625fd8","chunk-eda1b298":"c4ea1ffa","chunk-3f954034":"8eef457e","chunk-4fb06232":"cac18d35","chunk-59d3dc63":"a6882cf0","chunk-72851607":"078a99ad","chunk-77d11962":"4d0c036b","chunk-abc8e9de":"ddebd48c","chunk-bfb39cd6":"fad9e196","chunk-d86506f6":"8237dfc4","chunk-e9918708":"dd960915","chunk-2d237522":"412e5ee8","chunk-5427c800":"3441e01b","chunk-d67f0ec2":"26d8085d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-088ff9c4":1,"chunk-66c005f6":1,"chunk-17aa4263":1,"chunk-20d3da9c":1,"chunk-23d7671f":1,"chunk-75ae48cb":1,"chunk-26388ba0":1,"chunk-30685335":1,"chunk-330516b5":1,"chunk-373d13b6":1,"chunk-3ade2b2a":1,"chunk-51870f86":1,"chunk-713ff3a1":1,"chunk-1392692b":1,"chunk-c132eb58":1,"chunk-b7a736d6":1,"chunk-15cd8f4b":1,"chunk-e13d3680":1,"chunk-2b10fcfa":1,"chunk-727f3b75":1,"chunk-8eddf8fa":1,"chunk-eda1b298":1,"chunk-3f954034":1,"chunk-4fb06232":1,"chunk-59d3dc63":1,"chunk-72851607":1,"chunk-77d11962":1,"chunk-abc8e9de":1,"chunk-bfb39cd6":1,"chunk-d86506f6":1,"chunk-e9918708":1,"chunk-d67f0ec2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-088ff9c4":"dcee3812","chunk-0f6138b1":"31d6cfe0","chunk-3c1f000b":"31d6cfe0","chunk-66c005f6":"93c6440f","chunk-17aa4263":"6dd0c2e2","chunk-20d3da9c":"7c898ed6","chunk-23d7671f":"fc747705","chunk-75ae48cb":"235fa7da","chunk-26388ba0":"bbc1b58c","chunk-26b7f32c":"31d6cfe0","chunk-2d0c0c33":"31d6cfe0","chunk-2d21a9a9":"31d6cfe0","chunk-2d21f29d":"31d6cfe0","chunk-2d22ce37":"31d6cfe0","chunk-30685335":"3fd2e09c","chunk-330516b5":"9433c35a","chunk-373d13b6":"97bb8401","chunk-3ade2b2a":"f6b223af","chunk-51870f86":"11f210b3","chunk-713ff3a1":"bddb2160","chunk-1392692b":"be13864a","chunk-c132eb58":"8818cff8","chunk-b7a736d6":"098d3d5f","chunk-15cd8f4b":"62ba2dbd","chunk-e13d3680":"c35741a1","chunk-2b10fcfa":"9e64a419","chunk-727f3b75":"f806d22a","chunk-8eddf8fa":"71bf3bfd","chunk-eda1b298":"7f802405","chunk-3f954034":"f996b811","chunk-4fb06232":"c6b4ecff","chunk-59d3dc63":"95387096","chunk-72851607":"819dc80c","chunk-77d11962":"6f1fb8a9","chunk-abc8e9de":"52e1c3b6","chunk-bfb39cd6":"5a42745a","chunk-d86506f6":"dcca3df0","chunk-e9918708":"476d3d6a","chunk-2d237522":"31d6cfe0","chunk-5427c800":"31d6cfe0","chunk-d67f0ec2":"32a1be94"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static.www.yuugeai.com/static/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
